import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase-Konfiguration
// Firebase-Konfiguration
const firebaseConfig = {
    apiKey: "AIzaSyBIVxx7S7tRXQokRsiO-_fKjnGHoE3WxrE",
    authDomain: "farukiyyeappticket.firebaseapp.com",
    projectId: "farukiyyeappticket",
    storageBucket: "farukiyyeappticket.firebasestorage.app", // Aktualisiert!
    messagingSenderId: "679055350052",
    appId: "1:679055350052:web:81b069b5ae10363d413bb1",
    measurementId: "G-7E1BKE7DPJ"
};

// Firebase initialisieren
const app = initializeApp(firebaseConfig);

// Firestore, Authentication und Storage exportieren
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);